<template>
 <div class="live-container " :style="{height: bannerOpen ? '' : '218px'}">
    <div class="live-wrapper" :style="{top: bannerOpen ? '' : '0'}">
      <div class="main-title">
        <div class="link-list">
          <span class="text">今日直播</span>
        </div>
        <a
          :href="`/live.html?menuId=${menu.id}&name=${menu.menu_name}`"
          class="more-btn"
          style="margin-top: 4px"
          v-if="menu"
        >
          <span class="btn-text">查看全部</span>
          <i class="iconfont icongengduo"></i>
        </a>
      </div>
      <div class="content">
        <LiveCard v-for="(item, index) in liveList.slice(0, 2)" :key="index" :liveCount="liveList.length" :liveData="item" :menu="menu"></LiveCard>
      </div>
    </div>
 </div>
</template>

<script>
import LiveCard from './LiveCard.vue'
export default {
  name: 'Live',
  components: {
    LiveCard
  },
  props: {
    liveList: {
      type: Array
    },
    // 导航是否打开
    bannerOpen: {
      type: Boolean,
      default: true
    }
  },
  created() {
    this.getNavList()
  },
  data() {
    return {
      menu: null,
    }
  },
  methods: {
    async getNavList() {
      const res = await this.$http.getNavList()
      this.menu = res.find(item => item.menu_code == '10601')
      // console.log('menu', this.menu);
    },
  }
}
</script>

<style scoped lang="scss">
.live-container {
  width: 100%;
  height: 177px;
}
.live-wrapper {
  position: absolute;
  top: -42px;
  left: 0px;
  right: 0;
  margin: 0 auto;
  width: 1200px;
  height: 218px;
  padding: 20px;
  background: #fff;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
  z-index: 2;
  .main-title {
    display: flex;
    height: 28px;
    overflow: hidden;
    .link-list {
      flex: 1;
      font-size: 20px;
      line-height: 28px;
      .text {
        height: 28px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 28px;
        letter-spacing: 1px;
      }
    }
    .more-btn {
      flex: 0 0 74px;
      margin-right: 0;
    }
  }
  .content {
    display: flex;
  }
}

</style>